module.exports = "/_next/static/images/bcd3836d372c4b0c80a06fb810d4925c-card-xs.png";